//
//
//
//

    export default {
        data() {
            return {
            }
        },
        methods: {
        },
        //生命周期之创建完成
        created: function(){

          this.$router.go(-1);
//          window.location.reload();
        },
    }



// WEBPACK FOOTER //
// ./src/views/sx/index.vue